  <!-- Panel de fuentes -->
  <div *ngIf="view.showDetails" class="chat-details-backdrop" (click)="view.toggleDetails()"></div>
  <div class="chat-details" *ngIf="view.showDetails" [ngClass]="{ 'split': view.selectedSource }" id="chat-details" #detailsPanel>
    <div class="sheet-handle" aria-hidden="true"></div>
    <div class="details-header" id="chat-details-header">
      <h2 class="details-title" id="chat-details-title">{{ view.translate('chat.sources') }}</h2>
    </div>

    <!-- Lista de fuentes -->
    <div class="sources-list" id="chat-sources-list">
      <div *ngFor="let source of view.currentSources; let i = index; trackBy: view.trackBySource" class="source-item"
        [ngClass]="{ 'active': view.selectedSource === source, 'selected-chunk': source.selected }"
        (click)="view.selectSource(source); $event.stopPropagation()"
        (dblclick)="view.openContextModalForSource(source, $event)" (contextmenu)="view.onSourceRightClick($event, source)"
        [attr.title]="view.translate('chat.click_to_read_source')"
        id="chat-source-item-{{ source?.metadata?.document_id || source?.id || i }}">
        <div class="source-number" id="chat-source-number-{{i}}">{{ i + 1 }}</div>
        <div class="source-info" id="chat-source-info-{{i}}" >
          <div *ngIf="view.showDownloadedMessage" class="downloaded-message">
            <i class="fas fa-check-circle downloaded-message-icon"></i> {{
            view.translate('chat.downloaded') }}
          </div>
          <div class="source-title" id="chat-source-title-{{i}}">
            {{ source.original_filename || source.title }}
          </div>
          <div class="source-preview" *ngIf="source.content" id="chat-source-preview-{{i}}">
            {{ source.content.length > 90 ? (source.content | slice:0:90) + '…' : source.content }}
          </div>
          <div class="source-confidence" id="chat-source-confidence-{{i}}">
            <div class="confidence-label" id="chat-source-confidence-label-{{i}}">{{ view.translate('chat.relevance') }}:
            </div>
            <div class="confidence-bar" id="chat-source-confidence-bar-{{i}}">
              <div class="confidence-fill" [style.width.%]="source.score * 100" id="chat-source-confidence-fill-{{i}}">
              </div>
            </div>
            <div class="confidence-value" id="chat-source-confidence-value-{{i}}">{{ (source.score * 100).toFixed(0) }}%
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Context confirmation modal for sources (Ask only this) -->
    <div *ngIf="view.contextModalVisible" class="chat-source-context-backdrop" (click)="view.confirmContextSelection(false)">
      <div class="chat-source-context-modal" (click)="$event.stopPropagation()" [style.position]="'fixed'"
        [style.left.px]="view.contextModalX" [style.top.px]="view.contextModalY">
        <div *ngIf="!view.confirmContext" class="menu-list">
          <button type="button" (click)="view.beginContextQuestion()">{{ view.translate('documents.context.ask_only_this')
            }}</button>
        </div>
        <div *ngIf="view.confirmContext" class="confirm-block">
          <div class="confirm-text">{{ view.translate('documents.context.confirm_only_this') }}</div>
          <div class="confirm-actions">
            <button type="button" class="btn-confirm" (click)="view.confirmContextSelection(true)">{{ view.translate('common.yes')
              }}</button>
            <button type="button" class="btn-cancel" (click)="view.confirmContextSelection(false)">{{ view.translate('common.no')
              }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Detalle de la fuente -->
    <div class="source-details" *ngIf="view.selectedSource" id="chat-source-details">
      <div class="source-details-header" id="chat-source-details-header">
        <div class="source-details-title" id="chat-source-details-title">
          <i class="fas fa-file-alt" id="chat-source-details-title-icon"></i>
          {{ view.selectedSource.original_filename || view.selectedSource.title }}
          <span *ngIf="view.selectedSource.selected" class="badge bg-primary ms-2" id="chat-source-selected-badge">
            <i class="fas fa-star"></i> {{ view.translate('chat.selected_source') || 'Fuente seleccionada' }}
          </span>
        </div>
        <button type="button" class="close-source-details" [attr.aria-label]="view.translate('chat.close_detail')" (click)="view.clearSource()" id="chat-source-details-close-btn">
          <i class="fas fa-times" id="chat-source-details-close-icon"></i>
        </button>
      </div>
      <div class="source-content" id="chat-source-content">
        <!-- Resumen amigable (parseado del summary; ya no se muestra el JSON crudo) -->
        <div class="source-summary" *ngIf="view.selectedSourceSummary as summary" id="chat-source-summary">
          <div class="source-summary-tags"
            *ngIf="summary.category || summary.subcategory">
            <span class="source-tag source-tag--category" *ngIf="summary.category">
              <i class="fas fa-folder-open"></i> {{ summary.category }}
            </span>
            <span class="source-tag" *ngIf="summary.subcategory">
              <i class="fas fa-tag"></i> {{ summary.subcategory }}
            </span>
          </div>
          <div class="source-summary-keywords" *ngIf="summary.keywords.length">
            <span class="source-keyword" *ngFor="let kw of summary.keywords">{{ kw }}</span>
          </div>
          <div class="source-summary-dates" *ngIf="summary.detectedDates.length">
            <div class="source-date" *ngFor="let d of summary.detectedDates">
              <i class="fas fa-calendar-day"></i>
              <strong>{{ d.date }}</strong>
              <span class="source-date-context" *ngIf="d.context"> — {{ d.context }}</span>
            </div>
          </div>
          <div class="source-summary-text" *ngIf="summary.text">{{ summary.text }}</div>
        </div>
        <!-- Texto del fragmento citado -->
        <div class="source-fragment" *ngIf="view.selectedSource.content">
          <h3 class="source-fragment-title" id="chat-source-content-title">
            <i class="fas fa-quote-left"></i> {{ view.translate('chat.fragment_text') }}
          </h3>
          <div class="source-text" id="chat-source-content-text">{{ view.selectedSource.content }}</div>
        </div>
      </div>
      <div class="source-actions" id="chat-source-actions">
        <!-- Mostrar ubicación en el documento (descargable si hay URL) -->
        <a class="badge bg-secondary download-link" id="chat-source-location"
          [href]="view.selectedSource.location || null" [attr.download]="view.selectedSource.original_filename || ''"
          (click)="$event.stopPropagation(); view.onSourceDownloadClick($event, view.selectedSource)">
          {{ view.translate('chat.location') || 'Ubicación' }}: {{ view.selectedSource.location }}
        </a>
        <!-- Mostrar índice de fragmento si está disponible -->
        <span *ngIf="view.selectedSource.chunk !== undefined" class="badge bg-secondary ms-2" id="chat-source-chunk">
          {{ view.translate('chat.chunk') || 'Fragmento' }}: {{ view.selectedSource.chunk }}
        </span>
      </div>
    </div>
  </div>
